
import Vue from 'vue'

export default Vue.extend({
   name: 'TextAreaComponent',
   props: {
      id: String,
      label: String,
      value: String,
      placeholder: { type: String, default: '' },
      required: { type: Boolean, default: false },
      readonly: { type: Boolean, default: false },
      validate: { type: Boolean, default: false },
      hideLabel: { type: Boolean, default: false },
      warning: { type: String, default: '' },
      instructions: { type: String, default: '' },
      rows: { type: Number, default: 4 },
   },
   data() {
      return {
         initialValue: '',
         innerValue: '',
         dirty: false,
      }
   },
   computed: {
      validationFailed(): boolean {
         if (!this.required) {
            return false
         }
         if (!this.dirty && !this.validate) {
            return false
         }
         return !this.innerValue
      },
      helpBlock(): string {
         return `A value for ${this.label} is required`
      },
   },
   mounted() {
      this.innerValue = this.value
      this.initialValue = this.value
   },
   watch: {
      value(newValue: string) {
         if (newValue !== this.innerValue) {
            this.innerValue = newValue
            this.initialValue = newValue
         }
      },
   },
   methods: {
      onChange() {
         if (!this.dirty) {
            this.dirty = this.innerValue !== this.value
         }
         this.$emit('input', this.innerValue)
      },
   },
})
